import React from "react";
import { Box, Chip, Grid, Typography } from "@mui/material";
import { CheckCircle as CheckIcon } from "@mui/icons-material";
import {
  SettingDefinitionDto,
  SettingValueType,
} from "@swagger/typescript-fetch-goflyer";
import { useTranslation } from "react-i18next";
import { messages } from "../../../locales/messages";
import { MySettingCard } from "./MySettingCard";

interface MySettingsSectionProps {
  overrides: SettingDefinitionDto[];
  onSave: (
    category: string,
    settingKey: string,
    newValue: string,
    valueType: SettingValueType,
  ) => Promise<void> | void;
  onReset: (category: string, settingKey: string) => Promise<void> | void;
  readonly?: boolean;
}

export const MySettingsSection = ({
  overrides,
  onSave,
  onReset,
  readonly,
}: MySettingsSectionProps) => {
  const { t } = useTranslation();

  return (
    <Box data-testid="admin-user-settings-my-section" sx={{ mb: 4 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          mb: 1.5,
          pb: 1,
          borderBottom: "2px solid rgba(245, 130, 32, 0.3)",
        }}
      >
        <CheckIcon sx={{ color: "#f58220", fontSize: 20 }} />
        <Typography
          variant="h6"
          sx={{ fontWeight: 700, color: "#1a1a1a", fontSize: "16px" }}
        >
          {t(messages.My_Settings())}
        </Typography>
        <Chip
          label={overrides.length}
          size="small"
          sx={{
            height: "20px",
            fontSize: "11px",
            fontWeight: 600,
            bgcolor: "rgba(245, 130, 32, 0.1)",
            color: "#f58220",
          }}
        />
      </Box>
      <Grid container spacing={2}>
        {overrides.map((o) => {
          const key = `${o.setting.category}:${o.setting.settingKey}`;
          return (
            <Grid item xs={12} key={key}>
              <MySettingCard
                override={o}
                onSave={onSave}
                onReset={onReset}
                readonly={readonly}
              />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};
